<template>
  <div class="hot-form">
    <div class="title">一起播人员数据录入</div>
    <div class="form-item">
      <label>选择人员：</label>
      <div class="custom-select" @click.stop>
        <input
          type="text"
          v-model="searchText"
          :placeholder="selectedLabel"
          @focus="dropdownVisible = true"
          @input="dropdownVisible = true"
        />
        <i v-if="id" class="clear-btn" @click.stop="clearUser">×</i>
        <div class="dropdown-list" v-show="dropdownVisible">
          <div
            v-for="item in filteredUserOptions"
            :key="item.id"
            class="dropdown-item"
            :class="{ active: id === item.id }"
            @click="selectUser(item.id)"
          >
            {{ item.nickname }}
          </div>
          <div v-if="filteredUserOptions.length === 0" class="dropdown-empty">无匹配数据</div>
        </div>
      </div>
    </div>
    <div class="form-item">
      <label>已调整值:</label>
      <input type="number" v-model.number="ytzNum" disabled />
    </div>
    <div class="form-item">
      <label>调整值:</label>
      <input type="number" v-model.number="amount" />
      <button :disabled="loading" @click="setDataById">提交</button>
    </div>
    <!--<div class="form-item" v-if="dataLoaded && enteredDataList.length">
    <label>已录入数据：</label>
    <div class="data-list">
        <div class="data-item" v-for="item in enteredDataList" :key="item.id">
        <span class="data-name">{{ item.nickname }}</span>
        <span class="data-score">{{ item.score }}</span>
        </div>
    </div>
    </div>-->
    <loading :visible="loading" :message="statusMessage"></loading>
  </div>
</template>

<script>
import axios from '../axios-instance'
import userList from './data-0622.js'
import loading from '../page0518/loading'

export default {
  components: {
    loading
  },
  data () {
    return {
      loading: false,
      statusMessage: '处理中...',
      id: undefined,
      ytzNum: undefined,
      amount: undefined,
      userList,
      searchText: '',
      dropdownVisible: false,
      dataMap: {},
      dataLoaded: false
    }
  },
  computed: {
    filteredUserOptions () {
      const keyword = this.searchText.trim().toLowerCase()
      if (!keyword) return this.userList
      return this.userList.filter(item =>
        item.nickname.toLowerCase().includes(keyword)
      )
    },
    selectedLabel () {
      const person = this.userList.find(item => item.id === this.id)
      return person ? person.nickname : '请选择人员'
    },
    enteredDataList () {
      return Object.entries(this.dataMap)
        .map(([id, score]) => {
          const person = this.userList.find(item => String(item.id) === id)
          return { id, nickname: person ? person.nickname : id, score }
        })
        .filter(item => item.score !== undefined && item.score !== '')
    }
  },
  mounted () {
    this.getData()
    document.addEventListener('click', this.closeDropdown)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.closeDropdown)
  },
  methods: {
    closeDropdown () {
      this.dropdownVisible = false
    },
    selectUser (id) {
      this.id = id
      this.searchText = this.selectedLabel
      this.dropdownVisible = false
      this.userChange()
    },
    clearUser () {
      this.id = undefined
      this.searchText = ''
      this.dropdownVisible = false
      this.ytzNum = undefined
      this.amount = undefined
    },
    userChange () {
      this.amount = undefined
      this.ytzNum = this.dataMap[this.id] !== undefined ? this.dataMap[this.id] : undefined
    },
    getData () {
      this.loading = true
      this.dataLoaded = false
      return axios({
        url: 'https://yudao-api.yunlvltd.com/app-api/vote/kv/get/0622data',
        method: 'get',
        timeout: 120000,
        headers: {
          'tenant-id': 1
        }
      }).then(res => {
        if (res.data && res.data.code === 0 && res.data.data) {
          try {
            const parsed = JSON.parse(res.data.data)
            this.dataMap = parsed && typeof parsed === 'object' ? parsed : {}
            this.dataLoaded = true
          } catch (e) {
            console.error('0622data 解析失败：', e)
            this.dataMap = {}
            this.dataLoaded = false
          }
        }
      }).catch(() => {
        this.dataLoaded = false
      }).finally(() => {
        this.loading = false
      })
    },
    setDataById () {
      if (!this.id) {
        alert('请选择人员')
        return false
      }
      if (!this.dataLoaded) {
        alert('数据初始化失败，请刷新页面后重试')
        return false
      }
      if (isNaN(this.amount)) {
        alert('请输入分数')
        return false
      }
      if (this.loading) {
        return false
      }
      this.loading = true
      this.$set(this.dataMap, this.id, this.amount)
      axios({
        url: 'https://yudao-api.yunlvltd.com/app-api/vote/kv/set/0622data',
        method: 'post',
        data: {
          value: JSON.stringify(this.dataMap)
        },
        timeout: 120000,
        headers: {
          'tenant-id': 1
        }
      }).then(res => {
        if (res.data && res.data.code === 0) {
          this.ytzNum = this.amount
          alert('提交成功')
        }
      }).catch(err => {
        console.error(err)
        alert('提交失败')
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scope>
.hot-form {
  width: 500px;
  margin: 20px auto;
}
.title {
  width: 100%;
  text-align: center;
  font-weight: bold;
  margin: 20px 0;
  font-size: 24px;
}
.form-item {
  margin-bottom: 25px;
}

label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

input, select {
  width: 100%;
  padding: 5px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #ccc;
  box-sizing: border-box;
}

button {
  background-color: #5ca1d8;
  color: #fff;
  border: none;
  padding: 5px 20px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 4px;
  margin-top: 5px;
}

button:hover {
  background-color: #4b8cc4;
}

.custom-select {
  position: relative;
  width: 100%;
}

.custom-select input {
  width: 100%;
  height: 36px;
  padding: 0 30px 0 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  color: #606266;
  outline: none;
  box-sizing: border-box;
  cursor: pointer;
}

.custom-select input:focus {
  border-color: #409eff;
}

.clear-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  color: #c0c4cc;
  cursor: pointer;
  font-size: 16px;
  font-style: normal;
}

.clear-btn:hover {
  color: #909399;
}

.dropdown-list {
  position: absolute;
  top: 40px;
  left: 0;
  width: 100%;
  max-height: 240px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  z-index: 1000;
  box-sizing: border-box;
}

.dropdown-item {
  padding: 10px 12px;
  font-size: 14px;
  color: #606266;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dropdown-item:hover,
.dropdown-item.active {
  background: #f5f7fa;
  color: #409eff;
}

.dropdown-empty {
  padding: 20px 12px;
  text-align: center;
  color: #909399;
  font-size: 14px;
}

.data-list {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 8px 12px;
  background: #fafafa;
}

.data-item {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  font-size: 14px;
  color: #606266;
  border-bottom: 1px solid #eee;
}

.data-item:last-child {
  border-bottom: none;
}

.data-name {
  font-weight: 500;
}

.data-score {
  color: #409eff;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/page260622/page-modify-data.vue